import React,{useEffect} from "react";
import "./style.scss";
import CreateAppStepTwo from "components/CreateAppStepTwo";
import { observer } from "mobx-react-lite";
import useStores from "stores";
import qs from 'qs';

const Overview = observer(() => {
  const {  overviewStore } = useStores();
  const urlQuery = qs.parse(location.search, { ignoreQueryPrefix: true });
  const { appKey } = urlQuery;

   useEffect(() => {
     if(appKey){
       overviewStore.queryAppBaseInfo(appKey);
     }
  }, [appKey]);

  return (
    <div className="createApp">
      <CreateAppStepTwo
        itemData={overviewStore.applist[0] || {}}
        // itemData={frameStore.currentApp || {}}
      ></CreateAppStepTwo>
    </div>
  );
});
export default Overview;
